import { render, staticRenderFns } from "./DarkModePickerEl.vue?vue&type=template&id=1f523c7b&scoped=true&"
import script from "./DarkModePickerEl.vue?vue&type=script&lang=ts&"
export * from "./DarkModePickerEl.vue?vue&type=script&lang=ts&"
import style0 from "./DarkModePickerEl.vue?vue&type=style&index=0&id=1f523c7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f523c7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
